var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns has-text-centered justify-center"},[_c('div',{staticClass:"resetcss",staticStyle:{"width":"400px","height":"400px"}},[_c('pie-chart',{attrs:{"label":_vm.test}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }